export default "__VITE_ASSET__DkFUKDdi__"